import {
  PAYMENT_SESSION_FAIL,
  PAYMENT_SESSION_LOADING,
  PAYMENT_SESSION_SUCCESS,
  PAYMENT_UPSELL_HIDE,
  PAYMENT_UPSELL_SHOW,
} from '../types';

const initialState = {
  isLoading: false,
  error: null,
  showUpsell: false,
  upsellFrom: '',
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case PAYMENT_SESSION_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case PAYMENT_SESSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case PAYMENT_SESSION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case PAYMENT_UPSELL_SHOW:
      return {
        ...state,
        showUpsell: true,
        upsellFrom: payload.from,
        formCount: payload.formCount,
      };
    case PAYMENT_UPSELL_HIDE:
      return {
        ...state,
        showUpsell: false,
        upsellFrom: '',
        formCount: null,
      };
    default:
      return state;
  }
}
